import { makeApiRequests } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';

export const reportService = {
  getReport: async (requestBody, signal) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.GET_REPORTS,
      method: 'POST',
      requestBody: requestBody,
      signal: signal
    });
    return { response, error };
  },
  createReport: async requestBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CREATE_REPORT,
      method: 'POST',
      requestBody
    });
    return { response, error };
  },
  getReportTemplates: async requestBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.GET_REPORT_TEMPLATES,
      method: 'POST',
      requestBody
    });
    return { response, error };
  },
  updateReport: async (id, requestBody) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.REPORT_WITH_ID(id),
      method: 'PUT',
      requestBody
    });
    return { response, error };
  },
  updateReportPlaceholder: async (id, requestBody) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.UPDATE_REPORT_PLACEHOLDER(id),
      method: 'PUT',
      requestBody
    });
    return { response, error };
  },

  replaceReportPlaceholder: async (id, requestBody) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.REPLACE_REPORT_PLACEHOLDER(id),
      method: 'PUT',
      requestBody
    });
    return { response, error };
  },
  replaceReportBodyWithPlaceholder: async (id, requestBody) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.REPLACE_REPORT_BODY_WITH_PLACEHOLDER(id),
      method: 'PUT',
      requestBody
    });
    return { response, error };
  },
  deleteReport: async id => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.REPORT_WITH_ID(id),
      method: 'DELETE'
    });
    return { response, error };
  },
  getSystemPromptContext: async () => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.GET_SYSTEM_PROMPT_CONTEXT,
      method: 'GET'
    });

    return { response, error };
  }
};
